class FeaturedProductsGrid extends HTMLElement {
    connectedCallback() {
        this.grid = this.querySelector('[slot="grid"]');
        this.button = this.querySelector('[slot="button"]');
        if (!this.grid || !this.button) return;

        this.cards = Array.from(this.grid.querySelectorAll('.featured-product-card'));
        if (!this.cards.length) return;

        this.initialDesktop = parseInt(this.dataset.initialDesktop || '4', 10);
        this.initialMobile = parseInt(this.dataset.initialMobile || '2', 10);
        this.stepDesktop = parseInt(this.dataset.stepDesktop || '4', 10);
        this.stepMobile = parseInt(this.dataset.stepMobile || '2', 10);

        this.visible = this.currentLimit();
        this.updateVisibility();

        // Show more
        this.button.addEventListener('click', () => {
            this.visible += this.isMobile() ? this.stepMobile : this.stepDesktop;
            this.updateVisibility();
        });

        // Add‑to‑cart buttons inside cards
        this.cards.forEach((card) => {
            const addBtn = card.querySelector('.featured-add');
            if (!addBtn) return;

            addBtn.addEventListener('click', (event) => {
                event.preventDefault();
                const variantId = addBtn.getAttribute('data-variant-id');
                if (!variantId) return;

                const cartForm = card.querySelector('cart-form');
                if (!cartForm) {
                    console.error('No cart form found.');
                    return;
                }

                const payload = {
                    id: Number(variantId),
                    quantity: 1,
                    properties: {}
                };

                cartForm?.formDataAPI?.updateItems(payload);
                cartForm?.reqCart();
            });
        });

        // Resize
        this._lastWidth = window.innerWidth;

        this._resizeHandler = () => {
            const currentWidth = window.innerWidth;
            if (currentWidth === this._lastWidth) return; // ignore pure height changes
            this._lastWidth = currentWidth;

            const limit = this.currentLimit();
            if (limit !== this.visible) {
                this.visible = limit;
                this.updateVisibility();
            }
        };

        window.addEventListener('resize', this._resizeHandler);
    }

    disconnectedCallback() {
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
        }
    }

    isMobile() {
        return window.matchMedia('(max-width: 767px)').matches;
    }

    currentLimit() {
        return this.isMobile() ? this.initialMobile : this.initialDesktop;
    }

    updateVisibility() {
        this.cards.forEach((card, index) => {
            if (index < this.visible) {
                card.classList.remove('hidden');
            } else {
                card.classList.add('hidden');
            }
        });

        if (this.visible >= this.cards.length) {
            this.button.style.display = 'none';
        } else {
            this.button.style.display = '';
        }
    }
}

if (!customElements.get('featured-products-grid')) {
    customElements.define('featured-products-grid', FeaturedProductsGrid);
}
